import "typeface-roboto";
import "../../style/fonts.scss";

import * as React from "react";
import * as Sentry from "@sentry/react";
import { Observer } from "mobx-react";
import { ClickAndShipApp } from "./click-and-ship-app";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { Permission } from "../../context/permission";
import { theme } from "../../back-office/components/app-theme";
import { UserNotificationCenterContextProvider } from "../../common/component/notifications/notification-center/user-notification-center-context-provider";
import { LoginPage } from "../../common/component/login/login-page";
import { useWindowSize } from "../../common/hooks/use-window-size";
import { ChangePassword } from "./reset-password/change-password";
import AuthenticatedRoute from "../../common/navigation/authenticated-route";
import { UserSessionContextProvider } from "../../common/context/application-context/user-session-context-provider";
import { ErrorScreen } from "../../common/component/error-screen/error-screen";
import { SrmBlueReturnsRouter } from "../router/srm-blue-returns-router/srm-blue-returns-router";

export interface IAppRouterProps {
    locale?: string;
}

export const AppRouter = (props: IAppRouterProps) => {
    const windowSize = useWindowSize();

    if (windowSize.height !== -1 && windowSize.isMobile) {
        window.location.replace(`${window.location.origin}/scan-and-ship`);
        return <></>;
    }

    return <Observer>
        {() => <div key={props.locale} data-reactroot>
            <Sentry.ErrorBoundary fallback={<ErrorScreen />}>
                <ThemeProvider theme={theme}>
                    <UserSessionContextProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/change-password/:token?" element={<ChangePassword />} />
                                <Route path="/srm-blue-returns/*" element={<SrmBlueReturnsRouter />} />
                                <Route path="/*" element={
                                    <AuthenticatedRoute permission={Permission.FrontRead}>
                                        <UserNotificationCenterContextProvider>
                                            <ClickAndShipApp />
                                        </UserNotificationCenterContextProvider>
                                    </AuthenticatedRoute>
                                } />
                            </Routes>
                        </BrowserRouter>
                    </UserSessionContextProvider>
                </ThemeProvider>
            </Sentry.ErrorBoundary>
        </div>}
    </Observer>;
};
